import { createConsumer } from "@rails/actioncable"

function buildConsumer(token) {
  const protocol = window.location.protocol === "https:" ? "wss" : "ws"
  return createConsumer(`${protocol}://${window.location.host}/cable?token=${encodeURIComponent(token)}`)
}

function buildSubscription(consumer, identifier, handlers) {
  const subscription = consumer.subscriptions.create(identifier, {
    connected() {
      handlers.onConnected?.()
    },

    disconnected() {
      handlers.onDisconnected?.()
    },

    rejected() {
      handlers.onRejected?.()
    },

    received(data) {
      handlers.onEvent?.(data)
    }
  })

  return {
    send(action, payload = {}) {
      subscription.perform(action, payload)
    },

    unsubscribe() {
      subscription.unsubscribe()
      consumer.disconnect()
    }
  }
}

export function subscribeToUserChannel(token, handlers = {}) {
  return buildSubscription(buildConsumer(token), { channel: "UserChannel" }, handlers)
}

export function subscribeToRoomChannel(token, roomCode, handlers = {}) {
  return buildSubscription(
    buildConsumer(token),
    { channel: "RoomChannel", room_code: roomCode },
    handlers
  )
}
